"use client";
import React, { useState } from 'react';
import { Typography, Box, Grid, IconButton, Dialog, DialogTitle, DialogContent, CircularProgress } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

function ArticleView({ articles, selectedLegalActId, onSelectArticle }) {
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);
  const [loadingDialog, setLoadingDialog] = useState(false);

  const handleInfoClick = (sectionNumber) => {
    setOpenDialog(true);
    setLoadingDialog(true);
    fetch(`https://iids8vsrw0.execute-api.eu-north-1.amazonaws.com/test/get-legal-act?legal_act_id=${selectedLegalActId}&section_number=${sectionNumber}`)
      .then((response) => response.json())
      .then((data) => {
        setDialogContent(data);
        setLoadingDialog(false);
      })
      .catch((error) => {
        console.error('Error fetching legal act details:', error);
        setLoadingDialog(false);
      });
  };

  const handleArticleClick = (articleNumber) => {
    if (onSelectArticle) {
      onSelectArticle({
        legal_act_id: selectedLegalActId,
        article_number: articleNumber,
      });
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogContent(null);
  };

  // Find the maximum document_count value
  const maxDocumentCount = Math.max(...articles.map((article) => article.document_count));

  const groupedArticles = articles.reduce((acc, article) => {
    const range = Math.floor((parseInt(article.article_number) - 1) / 100) * 100 + 1;
    const rangeKey = `${range}-${range + 99}`;
    if (!acc[rangeKey]) {
      acc[rangeKey] = [];
    }
    acc[rangeKey].push(article);
    return acc;
  }, {});

  const sortedRanges = Object.keys(groupedArticles).sort((a, b) => parseInt(a) - parseInt(b));

  return (
    <Box>
      {sortedRanges.map((range) => (
        <Box key={range} style={{ marginBottom: '2rem' }}>
          {/* Range heading with white color */}
          <Typography variant="h6" style={{ marginBottom: '1rem', color: '#ffffff' }}>
            Pants {range}
          </Typography>
          <Grid container spacing={2}>
            {groupedArticles[range]
              .sort((a, b) => parseInt(a.article_number) - parseInt(b.article_number))
              .map((article, index) => (
                <Grid item xs={12} sm={6} md={4} key={index} style={{ marginBottom: '1rem' }}>
                  <Box onClick={() => handleArticleClick(article.article_number)} style={{ cursor: 'pointer' }}>
                    {/* Article number with count */}
                    <Typography variant="body1" style={{ marginBottom: '0.5rem', color: '#b0b0b0' }}>
                      Pants {article.article_number}{' '}
                      <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#a0a0a0' }}>
                        {article.document_count}
                      </span>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the parent click handler
                          handleInfoClick(article.article_number);
                        }}
                        style={{ marginLeft: '0.5rem' }}
                      >
                        <InfoIcon color="disabled" fontSize="inherit" />
                      </IconButton>
                    </Typography>

                    {/* Bar chart */}
                    <Box style={{ position: 'relative', height: '20px', display: 'flex', alignItems: 'center' }}>
                      <Box
                        style={{
                          width: `${(article.document_count / maxDocumentCount) * 100}%`,
                          height: '10px',
                          backgroundColor: '#81c784',
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
              ))}
          </Grid>
        </Box>
      ))}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>Legal Act Details</DialogTitle>
        <DialogContent>
          {loadingDialog ? (
            <CircularProgress />
          ) : dialogContent && dialogContent.content ? (
            <Box>
              <Typography variant="h6" gutterBottom>
                {dialogContent.section_title}
              </Typography>
              {dialogContent.content.map((paragraph, index) => (
                <Typography key={index} variant="body1" paragraph>
                  {paragraph}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography variant="body1">Error loading content.</Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default ArticleView;
